import Copy from "@/components/Copy";
import PresentData from "@/components/PresentData";
import ReturnCom from "@/components/ReturnCom"
import { mobileHidden } from "@/utils";
import useGetUserInfo from '@/web3Hook/useGetUserInfo';
import switchImg from "@/image/switch.svg";
import useAddressType from "@/store/addressType";
import useAddressConvert from "@/hooks/useAddressConvert";
import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Invite = () => {
    const { t } = useTranslation()
    const { userInfo, userInfoLod } = useGetUserInfo()
    const { address } = useConnectWallet()
    // 地址类型
    const { setAddressType, addressType } = useAddressType();

    // 地址转换
    const changeAddressType = () => {
        const type = addressType === "0x" ? "fb" : "0x";
        setAddressType(type);
    };
    // 地址转换
    const { addressConvert } = useAddressConvert();
    const [href, setHref] = useState(''); // 定义状态变量 href，用于存储当前页面的 URL

    useEffect(() => {
        const srt = `${window.location.origin}/invitation?invite_code=${addressConvert(address)}`; // 拼接推荐链接
        setHref(srt); // 更新状态变量 href
    }, [address, addressConvert]);
    return (
        <div className="mx-4 mt-3.5 md:max-w-[750px] md:mx-auto md:mt-6">
            <div>
                <ReturnCom title={t('invite.inviteFriends')} />
            </div>
            <div className="text-white mt-5.5 md:mt-8">
                <div className="mb-2.5 text-13px md:text-sm md:mb-3">{t('invite.inviteLink')}</div>
                <div className="border rounded-md border-ad h-12 md:h-14 px-2.5 md:px-4 flex items-center justify-between">
                    {
                        address && <>
                            < PresentData className="text-xs md:text-sm" value={mobileHidden(href, 20, 10)} loading={false} />
                            <Copy className="w-4 md:w-5" text={href || ""} />
                        </>
                    }
                </div>
            </div>
            <div className="text-white mt-5.5 md:mt-8">
                <div className="mb-2.5 text-13px md:text-sm md:mb-3">{t('invite.inviterAddress')}</div>
                <div className="border rounded-md border-ad h-12 md:h-14 px-2.5 md:px-4 flex items-center justify-between">
                    < PresentData className="text-xs md:text-sm" value={mobileHidden(addressConvert(userInfo.referrer))} loading={userInfoLod} />
                    <div className="flex items-center justify-between">
                        {userInfo.referrer && <>
                            <Copy className="w-4 md:w-5" text={addressConvert(userInfo.referrer) || ""} />
                            <img onClick={changeAddressType} src={switchImg} alt="" className="w-4 md:w-5 ml-3 md:ml-4 cursor-pointer hover:opacity-80 transition-opacity" />
                        </>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Invite